import { ref } from 'vue'
import { defineStore } from 'pinia'
import { HostCompany, type Me } from '@/types'

export const useAccountStore = defineStore('account', () => {
  const me = ref<Me>({
    username: '',
    last_name: '',
    first_name: '',
    is_active: false,
    parent_id: null,
    edi: {
      company_name: '',
      last_name: '',
      first_name: '',
      is_self_employee: false,
      current_date: new Date(),
    }
  })
  const hostCompany = ref<HostCompany>({
    name: '',
    president: '',
    icon: null,
    settings: {
      start_year: "2020",
      start_month: "01"
    }
  })

  const setMe = (data: Me) => {
    if (typeof data.edi.current_date === 'string') {
      data.edi.current_date = new Date(data.edi.current_date)
    }
    me.value = data
  }

  const getFullName = () => {
    const { first_name, last_name } = me.value
    if (first_name && last_name) {
      return `${last_name} ${first_name}`
    } else if (first_name || last_name) {
      return first_name || last_name
    } else {
      return ""
    }
  }

  // プロフィール系のラベル。協力会社のルートアカウントのみ「ルートアカウント」、
  // 個人事業主・協力会社のサブアカウントは「アカウント情報」（＝表示されるのは本人の情報のため）
  const getProfileLabel = () => {
    if (me.value.edi.is_self_employee) return 'アカウント情報'  // 個人事業主
    if (me.value.parent_id !== null) return 'アカウント情報'    // 協力会社のサブアカウント
    return 'ルートアカウント'                                   // 協力会社のルートアカウント
  }

  const setHostCompany = (data: HostCompany) => {
    hostCompany.value = data
  }

  return { me, hostCompany, setMe, getFullName, getProfileLabel, setHostCompany }
});
